export default __webpack_public_path__ + "static/media/as we fade ii.5e996f6a.jpg";